var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHamburger = function SvgIconHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91 7C2.406 7 2 6.552 2 6s.407-1 .91-1h18.18c.503 0 .91.448.91 1s-.407 1-.91 1H2.91zm0 6c-.503 0-.91-.448-.91-1s.407-1 .91-1h18.18c.503 0 .91.448.91 1s-.407 1-.91 1H2.91zM12 19c-.502 0-.91-.448-.91-1s.408-1 .91-1h9.09c.503 0 .91.448.91 1s-.407 1-.91 1H12z"
  })));
};
export default SvgIconHamburger;